import { CardBrandIcon } from "@/features/payment/components/CardBrandIcon";
import formatExpiry from "@/features/payment/utils/formatExpiry";
import { PaymentCard } from "../types";
import { Chip } from "@/components/ui/Chip";

export interface CardViewProps {
  card: PaymentCard;
  fallbackName?: string;
  hideCcofChip?: boolean;
}

export function CardView({ card, fallbackName, hideCcofChip }: CardViewProps) {
  return (
    <>
      {card.brand && <CardBrandIcon brand={card.brand} size="md" />}

      <div className="flex-1">
        <div className="flex items-center gap-2">
          <span className="text-sm font-bold">{card.last4}</span>
          {!hideCcofChip && (
            <Chip variant="disabled" size="sm" className="text-content-muted">
              Card on File
            </Chip>
          )}
        </div>
        <div className="text-content-muted mt-[3px] text-xs font-medium">
          {card.cardHolderName || fallbackName} &bull;{" "}
          {formatExpiry(card.expMonth ?? 0, card.expYear ?? 0)}
        </div>
      </div>
    </>
  );
}
